// extracted by mini-css-extract-plugin
module.exports = {"logo":"XDCm2r","boxText":"_7FNuP_","widget":"ggyIaR"};